<template>
    <div :class="{ 'flex justify-end': justifyEnd }">
        <input
            type="text"
            :name="name"
            class="form-input"
            :class="classes"
            ref="input"
            :size="size"
            :readonly="isReadOnly"
            :data-precision="isDecimal ? 2 : 0"
            v-bind:value="value"
            v-on:input="updateValue($event.target.value)"
            v-on:focus="selectAll"
            v-on:blur="formatValue"
        >
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: ''
            },

            size: {
                type: Number,
                default: 10
            },

            value: {
                type: [Number, String],
                default: 0
            },

            classes: {
                type: String,
                default: "text-xl text-right"
            },

            justifyEnd: {
                type: Boolean,
                default: false
            },

            isReadOnly: {
                type: Boolean,
                default: false
            },

            isDecimal: {
                type: Boolean,
                default: false
            }
        },

        mounted: function () {
            this.formatValue();
        },

        methods: {
            format: function (value) {
                if (value === null || value === '') return '';

                let raw = value?.toString().replace(/[^\d.-]/g, '');

                // if (this.isDecimal) {
                //     raw = parseFloat(raw).toFixed(1);
                // }

                if (raw) {
                    return raw.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }

                return '';
            },

            updateValue: function (value) {
                const result = this.format(value);

                this.$refs.input.value = result
                
                this.$emit('input', result)
            },

            formatValue: function () {
                this.$refs.input.value = this.format(this.$refs.input.value)
            },

            selectAll: function (event) {
                setTimeout(function () {
                    event.target.select()
                }, 0)
            }
        }
    }
</script>